import type { Challenge } from "../client";
import type {} from "cap-widget";
const active = new Map<string, Challenge>();
/** Cap's documented custom transport reuses an already issued, context-bound Shield challenge.
 * Only proof redemption reaches the server; the UI never treats its own success state as authorization.
 */
export function registerCapTransport(challenge: Challenge) {
  const endpoint = `/api/v1/security/challenge/widget/${challenge.id}/`;
  active.set(endpoint, challenge);
  window.CAP_CUSTOM_FETCH = async (input, init) => {
    const url = new URL(
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.href
          : input.url,
      location.origin,
    );
    if (url.origin !== location.origin)
      throw new Error("External Cap transport is disabled");
    const route = url.pathname.replace(/(challenge|redeem)$/, "");
    const current = active.get(route);
    if (!current) throw new Error("Verification expired");
    if (url.pathname === route + "challenge")
      return Response.json(current.data);
    if (url.pathname !== route + "redeem" || typeof init?.body !== "string")
      throw new Error("Invalid Cap request");
    const response = JSON.parse(init.body);
    const verified = await fetch("/api/v1/security/challenge/verify", {
      method: "POST",
      credentials: "same-origin",
      signal: init.signal,
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ id: current.id, response }),
    });
    const result = await verified.json();
    return Response.json(
      verified.ok && typeof result.pass === "string"
        ? {
            success: true,
            token: result.pass,
            expires: new Date(Date.now() + 240000).toISOString(),
          }
        : { success: false, error: "Verification expired or invalid" },
      { status: verified.status },
    );
  };
  return {
    endpoint,
    dispose: () => {
      if (active.get(endpoint) === challenge) active.delete(endpoint);
    },
  };
}
